import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisGeradoEditorPage from '@/pages/dashboard/documentos-digitais-gerado-editor-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar',
)({
  component: DocumentosDigitaisGeradoEditorPage,
})
